import React, { useState, useEffect } from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { API } from "@/App";
import { toast } from "sonner";

let _statsPromise = null;
const fetchStats = () => {
  if (!_statsPromise) _statsPromise = fetch(`${API}/match-ratings/stats`).then(r => r.ok ? r.json() : {}).catch(() => ({}));
  return _statsPromise;
};

export const MatchRating = ({ toolName, searchPrompt }) => {
  const [counts, setCounts] = useState({ up: 0, down: 0 });
  const [myVote, setMyVote] = useState(null);

  useEffect(() => {
    fetchStats().then(stats => { if (stats[toolName]) setCounts(stats[toolName]); });
  }, [toolName]);

  const vote = async (rating) => {
    if (myVote === rating) return;
    try {
      const res = await fetch(`${API}/match-rating`, {
        method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include",
        body: JSON.stringify({ tool_name: toolName, rating, search_prompt: searchPrompt || "" }),
      });
      if (res.status === 401) { toast.error("Sign in to rate matches"); return; }
      if (!res.ok) { toast.error("Failed to save rating"); return; }
      setCounts(prev => {
        const next = { ...prev };
        next[rating] += 1;
        if (myVote) next[myVote] = Math.max(0, next[myVote] - 1);
        return next;
      });
      setMyVote(rating);
      toast.success("Rating saved!");
    } catch (e) { toast.error("Something went wrong"); }
  };

  return (
    <div className="flex items-center gap-3 mt-2" data-testid={`match-rating-${toolName}`}>
      <span className="text-[10px] text-white/40">Rate this match:</span>
      <button onClick={() => vote("up")} className={`flex items-center gap-1 text-[11px] px-2 py-1 rounded-full border transition-colors ${myVote === "up" ? "border-neon bg-neon/10 text-neon" : "border-white/10 text-white/40 hover:border-neon/40 hover:text-neon"}`} data-testid={`match-rating-up-${toolName}`}>
        <ThumbsUp className="w-3 h-3" /> {counts.up}
      </button>
      <button onClick={() => vote("down")} className={`flex items-center gap-1 text-[11px] px-2 py-1 rounded-full border transition-colors ${myVote === "down" ? "border-red-400 bg-red-500/10 text-red-400" : "border-white/10 text-white/40 hover:border-red-400/40 hover:text-red-400"}`} data-testid={`match-rating-down-${toolName}`}>
        <ThumbsDown className="w-3 h-3" /> {counts.down}
      </button>
    </div>
  );
};

export default MatchRating;
